// Više naloga na istom browseru (kao profili u Chrome-u): svaki uspješan login
// pamti { id, ime, email, token } u localStorage pod ACCOUNTS_KEY, a aktivni
// nalog je i dalje onaj čiji je token u "restoran-token" — svi postojeći
// čitači tokena (plugins/axios.js, utils/menuUtils.js, router guard) ostaju
// nepromijenjeni. Prebacivanje samo zamijeni "restoran-token" i ponovo učita
// aplikaciju, a router guard (router/index.js) učita novog korisnika.
// Punjenje liste radi accountsPlugin (store/index.js) na svaki user/SAVE_USER.

export const ACCOUNTS_KEY = "restorani-accounts";
export const TOKEN_KEY = "restoran-token";

// Ključevi vezani za prethodnog korisnika — brišu se pri prebacivanju isto kao
// u user/LOGOUT (store/user.js), da novi nalog ne naslijedi izbor starog.
const PER_USER_KEYS = ["restorani-selected-restaurant", "restorani-lang"];

// "Dodaj drugi nalog": dok je ovaj flag postavljen, router guard umjesto
// učitavanja aktivnog naloga preusmjerava na login (vidi router/index.js).
const ADDING_ACCOUNT_KEY = "restorani-adding-account";

export function readAccounts() {
  try {
    const parsed = JSON.parse(localStorage.getItem(ACCOUNTS_KEY));
    return Array.isArray(parsed) ? parsed.filter((a) => a && a.id) : [];
  } catch (e) {
    return [];
  }
}

function writeAccounts(accounts) {
  try {
    localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(accounts));
  } catch (e) {}
  return accounts;
}

export function getActiveToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

// Naziv restorana / firme ispod imena — isti čovjek često ima naloge za više
// objekata, pa samo ime nije dovoljno da ih razlikuje.
function accountContext(user) {
  const owner =
    (user.restaurants && user.restaurants[0]) ||
    (user.companies && user.companies[0]) ||
    (user.suppliers && user.suppliers[0]);
  return owner && owner.name ? owner.name : "";
}

// Dodaje nalog ili osvježava postojeći (isti user.id) — novi token zamjenjuje
// stari, pa ponovni login na nalog kome je istekla sesija ga "oživi".
export function rememberAccount(user, token) {
  if (!user || !user.id || !token) return readAccounts();
  const account = {
    id: user.id,
    name: user.name || "",
    lastname: user.lastname || "",
    email: user.email || "",
    type: user.type || "",
    context: accountContext(user),
    token,
    lastUsedAt: Date.now(),
  };
  const others = readAccounts().filter((a) => a.id !== user.id);
  return writeAccounts([account, ...others]);
}

export function forgetAccount(id) {
  return writeAccounts(readAccounts().filter((a) => a.id !== id));
}

export function forgetAllAccounts() {
  try {
    localStorage.removeItem(ACCOUNTS_KEY);
  } catch (e) {}
  return [];
}

// Token je odbijen (401) — nalog ostaje u listi da bi korisnik mogao da se
// ponovo prijavi (email je već poznat), ali bez tokena.
export function expireAccount(id) {
  return writeAccounts(
    readAccounts().map((a) => (a.id === id ? { ...a, token: null } : a))
  );
}

// Kolačić "restoran-token" može biti postavljen i na roditeljskom domenu
// (cross-domain SSO), pa se briše na host-u i na svim roditeljskim domenima.
export function clearTokenCookie() {
  const expired = "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  document.cookie = TOKEN_KEY + expired;
  const parts = window.location.hostname.split(".");
  for (let i = 0; i < parts.length - 1; i++) {
    document.cookie =
      TOKEN_KEY + expired + " Domain=." + parts.slice(i).join(".") + ";";
  }
}

// Postavlja token naloga kao aktivan i učitava aplikaciju ispočetka na
// početnoj ruti — router guard tada povuče /user/me za novi nalog i preusmjeri
// ga na njegovu početnu stranicu (store, restoran, firma kreću od nule).
export function activateAccount(user, token) {
  rememberAccount(user, token);
  PER_USER_KEYS.forEach((key) => localStorage.removeItem(key));
  clearTokenCookie();
  localStorage.setItem(TOKEN_KEY, token);
  window.location.replace(window.location.pathname + window.location.search);
}

export function startAddingAccount(email) {
  sessionStorage.setItem(ADDING_ACCOUNT_KEY, email || "1");
}

export function isAddingAccount() {
  return !!sessionStorage.getItem(ADDING_ACCOUNT_KEY);
}

// Email naloga kome je istekla sesija (za popunjavanje login forme).
export function addingAccountEmail() {
  const value = sessionStorage.getItem(ADDING_ACCOUNT_KEY);
  return value && value !== "1" ? value : null;
}

export function stopAddingAccount() {
  sessionStorage.removeItem(ADDING_ACCOUNT_KEY);
}

export function accountInitials(account) {
  if (!account) return "";
  const first = String(account.name || "").trim().charAt(0);
  const second = String(account.lastname || "").trim().charAt(0);
  return (first + second).toUpperCase();
}
